// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"41e9fe5c","453":"4fe56638","455":"91ea9929"}[chunkId] + ".chunk.js";
};